module.exports = __webpack_public_path__ + "img/logo-sm.865c4138.png";